import {isLazyOcticonName, octiconComponent} from '@github-ui/lazy-octicon'
import {type Icon, NoteIcon} from '@primer/octicons-react'

import type {FieldIconName} from './fields'

/** `check-circle` to `CheckCircleIcon`, the octicon's component name. */
function toOcticonName(name: string): string {
  const pascalCase = name
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join('')
  return `${pascalCase}Icon`
}

/**
 * Resolves a field's icon name to its octicon, loaded on demand, so any octicon the server names
 * is drawn without a client change. An unknown name gets a generic icon.
 */
export function getFieldIcon(name: FieldIconName): Icon {
  const octiconName = toOcticonName(name)
  return isLazyOcticonName(octiconName) ? octiconComponent(octiconName) : NoteIcon
}
